import React from 'react';
import { Card, CardContent, CardHeader, CardTitle, CardDescription } from '../../components/ui/card';
import { Button } from '../../components/ui/button';
import { Badge } from '../../components/ui/badge';
import { Download, TrendingUp, CheckCircle, Clock, Target } from 'lucide-react';
import {
    BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer, Legend
} from 'recharts';

export default function EmployeePerformanceReport() {
    const performanceData = [
        { month: 'Aug', target: 50, achieved: 45 },
        { month: 'Sep', target: 50, achieved: 52 },
        { month: 'Oct', target: 50, achieved: 48 },
        { month: 'Nov', target: 60, achieved: 65 },
        { month: 'Dec', target: 60, achieved: 58 },
        { month: 'Jan', target: 60, achieved: 70 },
    ];

    return (
        <div className="space-y-6">
            <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4">
                <div>
                    <h1 className="text-2xl sm:text-3xl font-bold font-['Plus_Jakarta_Sans']">
                        My Performance
                    </h1>
                    <p className="text-muted-foreground mt-1">Track your personal KPIs and goals</p>
                </div>
                <Button variant="outline">
                    <Download className="h-4 w-4 mr-2" />
                    Export Report
                </Button>
            </div>

            <div className="grid grid-cols-1 sm:grid-cols-4 gap-4">
                <Card className="border border-border">
                    <CardContent className="pt-6">
                        <div className="flex items-center justify-between">
                            <div>
                                <p className="text-sm text-muted-foreground">Target Completion</p>
                                <p className="text-2xl font-bold">116%</p>
                                <div className="flex items-center gap-1 mt-1">
                                    <TrendingUp className="h-4 w-4 text-emerald-500" />
                                    <span className="text-xs text-emerald-500">+12% from last month</span>
                                </div>
                            </div>
                            <div className="p-3 rounded-xl bg-purple-100 text-purple-600">
                                <Target className="h-5 w-5" />
                            </div>
                        </div>
                    </CardContent>
                </Card>

                <Card className="border border-border">
                    <CardContent className="pt-6">
                        <div className="flex items-center justify-between">
                            <div>
                                <p className="text-sm text-muted-foreground">Files Processed</p>
                                <p className="text-2xl font-bold">338</p>
                                <div className="flex items-center gap-1 mt-1">
                                    <span className="text-xs text-muted-foreground">Total this year</span>
                                </div>
                            </div>
                            <div className="p-3 rounded-xl bg-blue-100 text-blue-600">
                                <CheckCircle className="h-5 w-5" />
                            </div>
                        </div>
                    </CardContent>
                </Card>

                <Card className="border border-border">
                    <CardContent className="pt-6">
                        <div className="flex items-center justify-between">
                            <div>
                                <p className="text-sm text-muted-foreground">Avg processing time</p>
                                <p className="text-2xl font-bold">2.4 Days</p>
                                <div className="flex items-center gap-1 mt-1">
                                    <TrendingUp className="h-4 w-4 text-emerald-500" />
                                    <span className="text-xs text-emerald-500">-0.5 days faster</span>
                                </div>
                            </div>
                            <div className="p-3 rounded-xl bg-orange-100 text-orange-600">
                                <Clock className="h-5 w-5" />
                            </div>
                        </div>
                    </CardContent>
                </Card>

                <Card className="border border-border">
                    <CardContent className="pt-6">
                        <div className="flex items-center justify-between">
                            <div>
                                <p className="text-sm text-muted-foreground">Rejection Rate</p>
                                <p className="text-2xl font-bold">8.4%</p>
                                <div className="flex items-center gap-1 mt-1">
                                    <span className="text-xs text-muted-foreground">Well below avg</span>
                                </div>
                            </div>
                            <div className="p-3 rounded-xl bg-emerald-100 text-emerald-600">
                                <TrendingUp className="h-5 w-5" />
                            </div>
                        </div>
                    </CardContent>
                </Card>
            </div>

            <Card className="border border-border">
                <CardHeader>
                    <CardTitle>Target vs Achieved Files</CardTitle>
                    <CardDescription>Monthly comparison over the last 6 months</CardDescription>
                </CardHeader>
                <CardContent>
                    <div className="h-[350px]">
                        <ResponsiveContainer width="100%" height="100%">
                            <BarChart data={performanceData}>
                                <CartesianGrid strokeDasharray="3 3" stroke="hsl(var(--border))" vertical={false} />
                                <XAxis dataKey="month" stroke="hsl(var(--muted-foreground))" fontSize={12} />
                                <YAxis stroke="hsl(var(--muted-foreground))" fontSize={12} />
                                <Tooltip
                                    contentStyle={{
                                        backgroundColor: 'hsl(var(--card))',
                                        border: '1px solid hsl(var(--border))',
                                        borderRadius: '8px',
                                    }}
                                />
                                <Legend />
                                <Bar dataKey="target" fill="#94a3b8" name="Target" radius={[4, 4, 0, 0]} />
                                <Bar dataKey="achieved" fill="#3b82f6" name="Achieved" radius={[4, 4, 0, 0]} />
                            </BarChart>
                        </ResponsiveContainer>
                    </div>
                </CardContent>
            </Card>
        </div>
    );
}
